export default __webpack_public_path__ + "static/media/pupper-alt.19cd5d74.png";